export const SHOW_RETAKE_UI = 'SHOW_RETAKE_UI';
export const HIDE_RETAKE_UI = 'HIDE_RETAKE_UI';
export const CHANGE_STATUS_RETAKE = 'CHANGE_STATUS_RETAKE';
